import React, { useRef, useState } from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    ReferenceInput,
    SearchInput,
    SelectInput,
    SimpleShowLayout,
    EditButton,
    ShowButton,
    Show,
    useTranslate,
    useListContext,
    TopToolbar, 
    CreateButton
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import jwt_decode from 'jwt-decode'
import { makeStyles } from '@material-ui/core/styles';
import LinkToProcessing from './LinkToProcessing';
import BarcodeCom from './BarcodeCom'
import moment from 'moment';
import moment2 from 'moment-timezone';
//import Card from '@material-ui/core/Card';
//import CardContent from '@material-ui/core/CardContent';
import ReactToPrint from "react-to-print";
import PrintDonor from './PrintDonor'
import LinkToPhysical from './LinkToPhysical'
import LinkToSpe from './LinkToSpe'
import LinkToAbsc from './LinkToAbsc'
import HistoryIcon from '@material-ui/icons/History';
import DonHostory from './LinkToHistory'
import ErrorBoundary from '../ErrorBoundary';
import DonorView from './DonorView'; 
//import { Typography, Box, Paper  } from '@material-ui/core';
//import { Paper, Box, Typography, Divider } from '@mui/material';
import { Grid, Typography, Box, Card, CardContent, Avatar, Divider, Paper,Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SafeImage, { SIGNATURE_PLACEHOLDER } from '../controls/SafeImage';



let level =  (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 );
let brcode =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';

const styles = {
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    hidden: {
        display: 'none'
    }
};

const useStyles =  makeStyles((theme) => ({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },

    title: {
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '90%',
        maxWidth: '800',
        alignItems: 'middle',
        border: 'double',
        fontSize: '14',
        fontWeight: 'bold'
    },

    table: {
        border: '1px solid black',
        width: '90%',
        maxWidth: '800',
        fontSize: '8',
        cellSpacing: '0',
        padding: '10px',
        borderCollapse: 'collapse',
        textAlign: 'center', 
        marginLeft: 'auto', 
        marginRight: 'auto' 
    },
    
    tableNoBorder: {
        border: '0px solid black',
        width: '90%',
        maxWidth: '800',
        fontSize: '10px',
        cellSpacing: '0',
        CellPadding: '8px',
        borderCollapse: 'collapse',
        textAlign: 'left', 
        marginLeft: 'auto', 
        marginRight: 'auto' 
    },
    tableOuter: {
        border: '0px',
        width: '100%',
        maxWidth: '800',
        fontSize: '10',
        borderCollapse: 'collapse',
        textAlign: 'center', 
        marginLeft: 'auto', 
        marginRight: 'auto' 
    },
    

    tdline: {
        borderBottom: '1px solid black'
    },

    content: { 
        padding: 0, 
        '&:last-child': { padding: 0 } 
    },

    img: {
        width: '7em',
        minWidth: '1em',
        maxWidth: '8em',
        maxHeight: '8em',
        borderRadius: '50%',
    },

    image: {
        width: '18em',
        minWidth: '1em',
        maxWidth: '20em',
        maxHeight: '20em',
        margin: '1em'
    },

    imgid: {
        maxWidth: '15em',
        maxHeight: '13em',
        borderRadius: '5%',
        bottom: '0',
    },

    sign: {
        width: '75px',
        hight: '25px'
    },

    signLabel: {
        verticalAlign:'baseline'
    },
    filterWrapper: {
        padding: theme.spacing(2),
        margin: theme.spacing(2),
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
    },
    filterForm: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: theme.spacing(2),
        align: 'center'
    },
    input: {
        width: '100%',
        '& .MuiInputBase-root': {
            height: 40,
            boxSizing: 'border-box',
        },
        '& .MuiInputBase-input': {
            padding: '10px 12px',
        },
        '& .MuiSelect-select': {
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    /*
    filterWrapper: {
    padding: theme.spacing(3),
    margin: theme.spacing(2),
    borderRadius: 16,
    backgroundColor: '#f9f9f9',
    boxShadow: theme.shadows[3],
    },
    filterForm: {
        display: 'grid',
        gap: theme.spacing(2),
        gridTemplateColumns: '1fr',
    },
    input: {
        backgroundColor: '#fff',
        borderRadius: 8,
    },
    */
}))


const useQuickFilterStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(3),
    },
}));

const QuickFilter = ({ label }) => {
    const translate = useTranslate();
    const classes = useQuickFilterStyles();
    return <Chip className={classes.root} label={translate(label)} />;
};

const dobStyle =  WrappedComponent => withStyles(coloredStyles)(
    ({ classes, ...props }) => (
        <WrappedComponent
            className={classnames({
                [classes.red]:  Math.floor(new Date().getTime() - new Date(props.record[props.source]))/ (1000 * 60 * 60 * 24 * 365)  > 60 ,
                [classes.blue]:  Math.floor(new Date().getTime() - new Date(props.record[props.source]))/ (1000 * 60 * 60 * 24 * 365)  < 18 ,
            })}
            {...props}
        />
    ));

const postRowStyle = (record, index) => ({
    backgroundColor: record.deferral_code === 'PR' ? '#f22' : 'white',
});

const coloredStyles = {
    red:    { color: 'red'},
    yellow: { color: 'yellow' },
    blue:   { color: 'blue' },
    orange:   { color: 'orange' },
};

const bgColoredStyles = {
    red:    { backgroundColor: 'red', fontWeight:'bold', color:'white', padding: '5px' },
    yellow: { backgroundColor: 'yellow', fontWeight:'bold', color:'navy', padding: '5px' },
    orange: { backgroundColor: 'orange', fontWeight:'bold', color:'white', padding: '5px' },
};

const colored = WrappedComponent => withStyles(bgColoredStyles)(
    ({ classes, ...props }) => (
        <WrappedComponent
            className={classnames({
                [classes.red]: props.record[props.source] === 'PR',
                [classes.yellow]: props.record[props.source] === 'TD' ,
                [classes.orange]: props.record[props.source] === 'ID' ,
            })}
            {...props}
        />
    ));


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
};



const ColoredTextField = colored(TextField)
const ColoredDateField = dobStyle(DateField)

export const DonorFilter = props => (
    <Filter {...props}>
        <SearchInput source="ssn" placeholder="SSN (Last 4 digits)SSN" alwaysOn  />
        <TextInput source="first_name" label="First Name"/>
        <TextInput source="last_name" label="Last Name"/>
        <DateInput source="dob" label="Donor DOB" locales="en-us"/>
        <TextInput source="don_ph" label="Donor phone" placeholder="000-000-0000"/>
        <TextInput source="deferral_code" label="Deferral code" />
        <DateInput source="deferral_exp_date" label="Deferral Exp date" locales="en-us"/>
      
    </Filter>
);

export const CustomDonorFilter = (props) => {
  const classes = useStyles();

  return (
    <Paper className={classes.filterWrapper}>
      <Box mb={2} textAlign="center">
        <Typography variant="h5" color="primary" fontWeight="bold">
          Donor Search
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Use one or more of the following criteria
        </Typography>
        <Divider sx={{ mt: 2 }} />
      </Box>

      <Filter {...props} formClassName={classes.filterForm}>
        <SearchInput
          source="ssn"
          placeholder="SSN (Last 4 digits)"
          alwaysOn
          className={classes.input}
          fullWidth
        />
        <SearchInput
          source="last_name"
          placeholder="Last Name"
          alwaysOn
          className={classes.input}
          fullWidth
        />
        <SelectInput
          source="deferral_code"
          label="Deferral Code"
          alwaysOn
          className={classes.input}
          fullWidth
          choices={[
            { id: 'N/A', name: 'N/A' },
            { id: 'ID', name: 'ID' },
            { id: 'PR', name: 'PR' },
            { id: 'TD', name: 'TD' },
          ]}
        />
      </Filter>
    </Paper>
  );
};

const ShowDetails = ({ record, basePath}) => {
    const classes = useStyles();
    const [openDialog, setOpenDialog] = useState(false);

    if (!record) return null;

    return (
        <>
        <Box className={classes.root} p={0}>
            <Grid container spacing={1}>
                <DetailItem label="SSN" value={record.ssn || ''} />
                <DetailItem label="Name" value={`${record.last_name}, ${record.first_name} ${record.middle_name || ''}`} />
                <DetailItem label="Gender" value={record.gender} />
                <DetailItem label="Date of Birth" value={moment2.tz(record.dob, 'America/New_York').format('MM/DD/YYYY')} />
                <DetailItem label="Address" value={`${record.apt || ''} ${record.street}, ${record.city || ''} ${record.zip || ''} ${record.state || ''}`} />
                <DetailItem label="Phone" value={record.don_ph} />
                <DetailItem label="Deferral" value={`${record.deferral_code} ${record.deferral_date ? moment(record.deferral_date).format('MM/DD/YYYY') : ''}`} />
                <DetailItem label="Deferral Exp" value={record.deferral_exp_date ? moment(record.deferral_exp_date).format('MM/DD/YYYY') : ''} />
                <DetailItem label="Deferral Comments" value={record.deferral_comments} />
                <DetailItem label="Allergies" value={record.allergies} />
                <DetailItem label="Status" value={record.status} />
                
                {record.donor_signature && (
                    <DetailItem
                        label="Signature"
                        value={<SafeImage src={record.donor_signature} fallbackSrc={SIGNATURE_PLACEHOLDER} alt="Donor signature" className={classes.sign} />}
                    />
                )}
            </Grid>
                
        </Box>
        <Box >
            <ShowButton  
                label="Show More >>" 
                sx={{
                    border: '1px solid #1976d2',      // Customize border color
                    borderRadius: '4px',              // Optional: rounded corners
                    padding: '4px 12px',              // Optional: spacing
                    color: '#1976d2',                 // Match text color if needed
                    fontWeight: 500
                }}
                basePath={basePath} record={record} 
            />
        </Box>
        
    </>
    );
};

const DetailItem = ({ label, value }) => (
    <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="textSecondary">
            <strong>{label}:</strong> {value || '—'}
        </Typography>
    </Grid>
);


const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <PrintDonor record={record} classes={classes} ref={componentRef} />
            <br />
            <ReactToPrint
            trigger={() => <button>Print this out!</button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };



const DonorShow = (props ) =>(
   
    <SimpleShowLayout style={styles.container}  {...props}>
        <ShowDetails props={props} />    
    </SimpleShowLayout>
 
);

const CustomEmpty = () => {
    const { displayedFilters, filterValues, setFilters, showFilter, resource } = useListContext();

    return (
        <Box m={2}>
            <CustomDonorFilter />
            <Typography variant="h6" align="center" color="navy" gutterBottom>
                No Donor found
            </Typography>
        </Box>
    );
};

const DonorListActions = () => (
    <TopToolbar>
        <CreateButton label="Create Donor" />
    </TopToolbar>
);

const GetAvatar = ({ record }) => {
    const classes = useStyles();

    return (
        <Avatar 
            src={record.photo_url} 
            alt="Donor Photo" 
            className={classes.img} 
            sx={{ width: 40, height: 40 }} 
        />
    )
}

export const DonorList = ({ classes, permissions, ...props }) => (
   
    <ErrorBoundary>
   
    <List    
        classes={classes}
        {...props}
        filters={<DonorFilter />}
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
        
        >
        <Datagrid  classes={{ headerCell: classes.header }} expand={<DonorShow />}  >
            <GetAvatar />
            <TextField source="ssn"     label="SSN"/>
            <TextField source="name"    label="Name"/>
            <ColoredTextField source="deferral_code"    label="Deferral code"/>
            
            { ((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) == 'PHYN' ||
              ((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 4 && 
              (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) !== 'PLAP'  &&
              (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 99)) && <LinkToSpe brcode={brcode}/> }

            {((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) == 'PHYN' ||
             ((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 4 && 
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 6 )) &&  <LinkToPhysical /> }
            
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1 &&  <LinkToProcessing  brcode={brcode}/> }
        
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1 &&
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 3 &&
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 4 && 
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 5 &&
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 6 && <EditButton label='' />}
            
            {/** 
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 3 &&
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 4 && <DonHostory label='' /> **/}
             
        </Datagrid>
    </List>
    </ErrorBoundary>
);


export default withStyles(listStyles, styles)(DonorList)